import _ from 'lodash';
import { mapMutations } from 'vuex';

/**
 * Auto-add capacity mixin for LARGE_MEETING
 * Provides intelligent capacity selection and auto-add to cart functionality
 */
export default {
  computed: {
    // all unselected capacity
    allAvailableCapacityOrderList() {
      return _.filter(this.allCapacityOrderList, capacity => {
        const isSelected = _.find(this.selectedPlanList, p => p.capacity === capacity);
        return !isSelected;
      });
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    /**
     * Get latest added capacity plan info
     * @returns {Object} { capacity, billing_cycle }
     */
    getLatestAddedCapacityPlan() {
      const configRows = _.chain(this.$refs)
        .keys()
        .filter(key => /configRow\d+/.test(key))
        .map(key => {
          const instance = _.get(this.$refs, [key, 0]);
          if (instance) {
            const attrs = instance.$attrs;
            return {
              index: attrs.index,
              capacity: attrs.capacity,
              billing_cycle: instance.billingCycle,
            };
          }
          return null;
        })
        .filter(Boolean)
        .orderBy(['index'], ['desc'])
        .value();
      let { capacity, billing_cycle } = _.get(configRows, [0]) || _.last(this.selectedPlanList);

      return {
        capacity,
        billing_cycle,
      };
    },
    /**
     * Override parent handleAddCapacity to auto-add plan to cart
     * Intelligently matches billing_cycle from the last added plan
     * @param {Event} event - click event
     */
    handleAddCapacity(event) {
      // Get latest added plan's billing_cycle
      let { billing_cycle } = this.getLatestAddedCapacityPlan();

      // Get next available capacity (first one in ascending order)
      const nextCapacity = this.allAvailableCapacityOrderList[0];

      // If no more capacity available, do nothing
      if (!nextCapacity) {
        return;
      }

      // Find matching plan: prioritize same billing_cycle, fallback to any available plan for this capacity
      const nextPlan = _.find(this.planList, p => p.capacity === nextCapacity && p.billing_cycle === billing_cycle)
        || _.find(this.planList, p => p.capacity === nextCapacity);

      // Auto-add to cart with license = 1
      if (nextPlan?.plan_code) {
        this.updateSelectPlan({
          plan_code: nextPlan.plan_code,
          cartInfo: {
            selected_number: 1,
          },
        });
      }

      // Update visible list and trigger hooks
      this.visibleCapacityList = _.concat(this.visibleCapacityList, nextCapacity);
      this.afterAddCapacityHook?.(nextCapacity);
      this.handleAddCapacityTracking?.(event, nextCapacity);
    },
  }
};

